import moment, { unitOfTime } from 'moment'
import { DatePeriodEnum } from '@/types/enums'

export class DatePeriod {
  private constructor (
    readonly number: number,
    readonly startDate: Date,
    readonly endDate: Date,
    readonly period: DatePeriodEnum
  ) {}

  get startDateString (): string {
    return this.startDate.toISOString()
  }

  get endDateString (): string {
    return this.endDate.toISOString()
  }

  public formattedStartDate (format: string): string {
    return moment(this.startDate).format(format)
  }

  public formattedEndDate (format: string): string {
    return moment(this.endDate).format(format)
  }

  public static createFromDateString (dateString: string, period: DatePeriodEnum): DatePeriod {
    let begin, end
    let periodCode: unitOfTime.StartOf = 'month'
    let periodFormat = 'MM'

    if (period === DatePeriodEnum.Day) {
      periodCode = 'day'
      periodFormat = 'DD'

      begin = moment(dateString).startOf(periodCode)
      end = moment(dateString).endOf(periodCode)
    } else if (period === DatePeriodEnum.Week) {
      periodCode = 'isoWeek'
      periodFormat = 'w'

      begin = moment(dateString).isoWeekday(1).startOf(periodCode)
      end = moment(dateString).isoWeekday(1).endOf(periodCode)
    } else if (period === DatePeriodEnum.WorkingWeek) {
      periodCode = 'isoWeek'
      periodFormat = 'w'

      begin = moment(dateString).isoWeekday(1).startOf(periodCode)
      end = moment(dateString).isoWeekday(1).endOf(periodCode).subtract(2, 'days')
    } else if (period === DatePeriodEnum.Year) {
      periodCode = 'year'
      periodFormat = 'YYYY'

      begin = moment(dateString).startOf(periodCode)
      end = moment(dateString).endOf(periodCode)
    } else {
      begin = moment(dateString).startOf(periodCode)
      end = moment(dateString).endOf(periodCode)
    }

    return new DatePeriod(
      parseInt(end.format(periodFormat)),
      begin.toDate(),
      end.toDate(),
      period
    )
  }

  public static createFromNow (period: DatePeriodEnum): DatePeriod {
    let periodCode: unitOfTime.StartOf = 'month'
    let periodFormat = 'MM'

    if (period === DatePeriodEnum.Week) {
      periodCode = 'isoWeek'
      periodFormat = 'w'
    } else if (period === DatePeriodEnum.WorkingWeek) {
      periodCode = 'isoWeek'
      periodFormat = 'w'
    }

    const begin = moment().startOf(periodCode)
    const end = moment().endOf(periodCode)

    return new DatePeriod(
      parseInt(end.format(periodFormat)),
      begin.toDate(),
      end.toDate(),
      period
    )
  }
}
